const formList = require('./ReadOnlyFormList');

function asDataDictionary(hNode, context) {
    return formList.asDataDictionary(hNode, context);
}

module.exports = { asDataDictionary };
